import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  > * {
    width: 100%;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AudioPlayer = ({ url }) => (
  <Layout>
    {/* eslint-disable jsx-a11y/media-has-caption */}
    <audio controls src={url} />
  </Layout>
)

AudioPlayer.propTypes = {
  url: PropTypes.string.isRequired,
}

export default AudioPlayer
